export default {"src":"/games/_next/static/media/edhrec_white.f2dd50a4.svg","height":287,"width":270,"blurWidth":0,"blurHeight":0};